import { render, staticRenderFns } from "./OktaCallback.vue?vue&type=template&id=4bc9e44a"
import script from "./OktaCallback.vue?vue&type=script&lang=js"
export * from "./OktaCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports